/**
 * EasyGo Carrier Detachable Handle Pair
 * - PDP 桌面 2×2 右上变体格：由 product-pdp-2x2-variant-sync.js 按 variant 主图同步（勿再列入其 CDN 排除名单）。
 * - 本文件：Customize 主图兜底 + 静态 6 图列表（供调试/定制页）。
 */

(function() {
  'use strict';

  console.log('🔧 [EasyGoHandle] 脚本开始加载...');

  // ========== 配置 ==========
  const PRODUCT_NAME = 'EasyGo Carrier Detachable Handle Pair';
  const PRODUCT_HANDLES = [
    'easygo-carrier-detachable-handle-pair',
    'easygo-detachable-handle-pair',
    'detachable-handle-pair'
  ];
  
  // 产品图片URLs
  const PRODUCT_IMAGES = [
    'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/1_c236f2e1-1d99-4e99-a74e-91030df0ddee.png?v=1765658322',
    'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/2_64a064d4-2f89-4eb0-ac4d-4bd498ad7075.png?v=1765658326',
    'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/3_b4beff97-9ef8-41d6-a29b-8d155dff0b10.png?v=1765658327',
    'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/4_a8d5d548-61d2-494e-9874-6c0910fa3a43.png?v=1765658327',
    'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/5_e51be603-8c6c-4fcb-ad51-bae49f4da4b6.png?v=1765658327',
    'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/6_8717d296-1321-4cd8-ad8e-4c4760dd189b.png?v=1765658326'
  ];

  // ========== 工具函数 ==========
  
  // 检测是否在 customize 构建器页面
  function isCustomizePage() {
    return document.querySelector('.custom-builder') !== null;
  }

  // 检查是否应该运行(只对 EasyGo Carrier Detachable Handle Pair 启用)
  function shouldRun() {
    // Customize 页面
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && productSelect.options.length > 0) {
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        if (selectedOption) {
          const selectedName = selectedOption.textContent.trim();
          const selectedHandle = selectedOption.value;

          // 检查名称或 handle 是否匹配
          const nameMatch = selectedName.includes('EasyGo') && 
                           selectedName.includes('Detachable Handle') &&
                           selectedName.includes('Pair');
          const handleMatch = PRODUCT_HANDLES.some(h => selectedHandle.includes(h));

          if (nameMatch || handleMatch) {
            console.log('✅ [EasyGoHandle] Customize页面匹配:', selectedName, '| Handle:', selectedHandle);
            return true;
          }
        }
      }
      return false;
    }

    // 普通产品页面:检查 URL 和标题
    const url = window.location.href.toLowerCase();
    const pageTitle = document.title.toLowerCase();

    // 检查 URL 或标题中是否包含产品关键词
    const hasProductKeywords = (
      (url.includes('easygo') && url.includes('handle') && url.includes('pair')) ||
      (url.includes('detachable-handle')) ||
      (pageTitle.includes('easygo') && pageTitle.includes('handle') && pageTitle.includes('pair'))
    );

    if (hasProductKeywords) {
      console.log('✅ [EasyGoHandle] 产品页面匹配 (URL/标题包含关键词)');
      return true;
    }

    // 检查 URL 中是否包含产品 handle
    const hasHandle = PRODUCT_HANDLES.some(handle => url.includes(handle));
    
    if (hasHandle) {
      console.log('✅ [EasyGoHandle] 产品页面匹配 (URL包含产品handle)');
      return true;
    }

    return false;
  }

  // ========== 主要功能 ==========

  // 确保产品图片正确显示
  function ensureProductImages() {
    if (!shouldRun()) {
      console.log('⏭️ [EasyGoHandle] 不是目标产品，跳过');
      return;
    }

    console.log('🔧 [EasyGoHandle] 开始确保产品图片显示...');

    if (isCustomizePage()) {
      // Customize 页面：确保主图显示第一张产品图
      const mainImage = document.querySelector('.custom-builder .main-image');
      if (mainImage && PRODUCT_IMAGES.length > 0) {
        // 如果当前图片不是我们的产品图，更新为第一张
        const isOurImage = PRODUCT_IMAGES.some(imgUrl => mainImage.src.includes(imgUrl.split('/').pop().split('?')[0]));
        if (!isOurImage) {
          console.log('🔧 [EasyGoHandle] Customize页面：更新主图为第一张产品图');
          mainImage.src = PRODUCT_IMAGES[0];
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
        }
      }
    } else {
      // 产品页面：确保图片库包含所有6张图片
      // 这里主要是确保 Shopify 的产品媒体库正确显示所有图片
      // 如果 Shopify 已经正确配置了产品媒体，则不需要额外操作
      console.log('🔧 [EasyGoHandle] 产品页面：检查产品媒体库');
      
      // 检查主图是否显示正确
      const mainImageContainer = document.querySelector('.main-image, .product__media-item, .product-single__photo');
      if (mainImageContainer) {
        console.log('✅ [EasyGoHandle] 找到主图容器');
      }
    }
  }

  // 初始化
  function init() {
    if (!shouldRun()) {
      console.log('⏭️ [EasyGoHandle] 不是目标产品,跳过初始化');
      return;
    }

    console.log('✅ [EasyGoHandle] 开始初始化...');

    // 确保产品图片显示
    ensureProductImages();

    // Customize 页面：监听产品切换
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && !productSelect.dataset.easygoHandleBound) {
        productSelect.dataset.easygoHandleBound = 'true';

        productSelect.addEventListener('change', function() {
          const selectedOption = this.options[this.selectedIndex];
          const productName = selectedOption ? selectedOption.textContent.trim() : '';
          console.log('🔄 [EasyGoHandle] 产品切换:', productName);
          
          setTimeout(() => {
            if (shouldRun()) {
              ensureProductImages();
            }
          }, 300);
        });
      }

      // 监听选项容器变化
      const optionsWrapper = document.getElementById('product-option-groups');
      if (optionsWrapper) {
        console.log('👀 [EasyGoHandle] 启动 Customize 页面选项区域监听');
        const optionsObserver = new MutationObserver(function(mutations) {
          const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
          if (hasNewNodes) {
            console.log('👀 [EasyGoHandle] 检测到选项区域更新');
            setTimeout(() => {
              if (shouldRun()) {
                ensureProductImages();
              }
            }, 300);
          }
        });
        
        optionsObserver.observe(optionsWrapper, {
          childList: true,
          subtree: true
        });
      }
    }

    console.log('✅ [EasyGoHandle] 初始化完成');
  }

  // 延迟初始化
  function delayedInit() {
    const delay = isCustomizePage() ? 2000 : 500;
    setTimeout(() => {
      if (shouldRun()) {
        init();
      } else if (isCustomizePage()) {
        // Customize 页面再等一次
        setTimeout(() => {
          if (shouldRun()) init();
        }, 2000);
      }
    }, delay);
  }

  // 启动脚本
  if (isCustomizePage() || shouldRun()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', delayedInit);
    } else {
      delayedInit();
    }
  }

  // 暴露全局函数供调试
  window.EasyGoHandlePair = {
    ensureImages: ensureProductImages,
    reinit: init,
    getImages: function() {
      return PRODUCT_IMAGES;
    }
  };

  console.log('🔧 EasyGo Carrier Detachable Handle Pair 图片系统已加载!');
  console.log('💡 调试命令:');
  console.log('   EasyGoHandlePair.ensureImages() - 手动确保图片显示');
  console.log('   EasyGoHandlePair.getImages() - 查看所有产品图片URL');
})();
